import { Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { FLAG_PRIORITY_CODINGS } from "../constants/flags";
import { CLIENT_FLAG_ROW_PROPS } from "../constants/ui";
import { ClientFlag } from "../interfaces/client-flags";

import FlagDeprecatedBadge from "./FlagDeprecatedBadge";
import FlagPriorityDot from "./FlagPriorityDot";

/**
 * One applied flag: priority dot and name on the left, priority on the right — or the `Deprecated`
 * chip in its place once the library entry is gone.
 */
export default function ClientFlagRow({ flag }: { flag: ClientFlag }) {
  return (
    <Group {...CLIENT_FLAG_ROW_PROPS} data-testid={`client-flag-row-${flag.id}`}>
      <Group gap="sm" wrap="nowrap">
        <FlagPriorityDot priority={flag.priority} isDeprecated={flag.isDeprecated} />
        <TextWrapper>{flag.name}</TextWrapper>
      </Group>
      {flag.isDeprecated && <FlagDeprecatedBadge />}
      {!flag.isDeprecated && flag.priority && (
        <TextWrapper c="dark.9" ta="right" variant="semibold">
          {FLAG_PRIORITY_CODINGS[flag.priority].display}
        </TextWrapper>
      )}
    </Group>
  );
}
